import React, { useState, useEffect }from 'react'
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Map from '../Pincode/Map-of-india.JPG';
import PincodeImg from '../Pincode/Pincode-structure.JPG';
import { Helmet } from "react-helmet-async";



function PincodeAccess() {
  const [message, setMessage] = useState('110007');
  const [updated, setUpdated] = useState(message);
  const pin = `https://api.postalpincode.in/pincode/${updated}`;



  const [data, setData] = useState([]);

  const fetchApiData = async (url) => {
  try {
    const res = await fetch(url); //fetch API as url
    // console.log('hello 1', url)
    const response = await res.json();
    // console.log('hello 2')
    setData(response); // convert response in JSON
    // console.log('hello 3')
    console.log(response);

  } catch (error) {
    console.log(error);
  }
  };


  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleClick = () => {
    // 👇 "message" stores input field value
    setUpdated(message);
    // fetchApiData(updated);
  };


  useEffect(() => {
    fetchApiData(pin);
  },[pin]);
  


  return (
    <>

      <Helmet>
      <title> Pincode Search </title>
      <meta name="description" content="Our Indian Pin code database has almost 1,54,700 post office pin code specifics, as well as their location, district, and state information. You can also discover"/>
      </Helmet>




     <div style={{marginTop: '30px' , marginBottom: '30px'  }} className="container">
        <div className='d-flex justify-content-center'>
        <h5> <b>Enter Pincode Here</b></h5>
        </div>
        <div className='d-flex justify-content-center'>
        <input type="number" id="message" name="message" onChange={handleChange} pattern="[0-9]+" value={message} style={{width:'200px' ,marginBottom: '30px'}}/>
        </div>
        <div className='d-flex justify-content-center'>
        <button onClick={handleClick} style={{width: '200px'}}>Search</button>
        </div>

        <div className='d-flex align-content-stretch justify-content-around flex-wrap' style={{marginTop: '30px'}}>
          
          {
           data.map((da) => {
            
              return ( da.Status === "Success" ?  da.PostOffice.map((po) => {
                return (
                
                  <Card style={{ maxWidth: "300px", padding:"5px", margin: "10px"}} key={po.Name}>
                  <Card.Header style={{ minWidth: "290px"}}><h5>{po.Name}</h5></Card.Header>
                  <ListGroup variant="flush" >
                    <ListGroup.Item>District : {po.District}</ListGroup.Item>
                    <ListGroup.Item>Division : {po.Division}</ListGroup.Item>
                    <ListGroup.Item>Region  : {po.Region}</ListGroup.Item>
                    <ListGroup.Item>State : {po.State}</ListGroup.Item>
                    <ListGroup.Item>Country : {po.Country}</ListGroup.Item>
                    <ListGroup.Item>Pincode : {po.Pincode}</ListGroup.Item>
                  </ListGroup>
                  </Card>
               
                )

            }) : <div className='d-flex justify-content-center'> 
            <div className='d-flex'><h2>Wrong Pincode Bro</h2></div>
            </div>)

          })
         
          }
            
          <div style={{ width:"70%" ,marginTop: "20px" ,marginBottom:"20px" }}>
            <h2>About Pincode in India</h2><br/>
            <p>Because India is a big country, it is nearly hard to recall the Pincode of any specific area within a city/town/village or to identify a location using its Pincode.<br/><br/>
               We bring to you our Pincode search engine to assist you in locating a Pincode or location. You may now quickly search for a certain area's Pincode as well as the address of any location in India using its Pincode. All of this is just a click away.<br/><br/>
               Our goal with this area is to meet the needs of people and businesses looking for Pincodes or addresses of localities across India. We have a location in the isolated highlands of Jammu and Kashmir as well as the deserts of Rajasthan.<br/><br/>
            </p><br/>
            <h2>1st 2 Digits of PINcode, Postal Circle :</h2>
            <ul>
                <li>11 - Delhi</li>
                <li>12 - 13 Haryana</li>
                <li>14 - 16 Punjab</li>
                <li>17 - Himachal Pradesh</li>
                <li>18 - 19 Jammu & Kashmir</li>
                <li>20 - 28 Uttar Pradesh</li>
                <li>30 - 34 Rajasthan</li>
                <li>36 - 39 Gujarat</li>
                <li>0 - 44 Maharashtra</li>
                <li>45 - 48 Madhya Pradesh</li>
                <li>49 - Chhattisgarh</li>
                <li>50 - 53 Andhra Pradesh</li>
                <li>50 - 53 TELANGANA</li>
                <li>56 - 59 Karnataka</li>
                <li>60 - 64 Tamil Nadu</li>
                <li>67 - 69 Kerala</li>
                <li>682- Lakshadweep</li>
                <li>70 - 74 West Bengal</li>
                <li>744- Andaman & Nicobar</li>
                <li>75 - 77 Orissa</li>
                <li>78 - Assam</li>
                <li>79 - Arunachal Pradesh</li>
                <li>79 - Manipur</li>
                <li>79 - Meghalaya</li>
                <li>79 - Mizoram</li>
                <li>79 - Nagaland</li>
                <li>79 - Tripura</li>
                <li>80 - 85 Bihar</li>
                <li>80 - 83, 92 Jharkhand</li>
            </ul>
            <h2>What is Pin (Postal Index Number)</h2>
            <p>
            Do you ever worry if a letter or parcel sent through the Indian postal system or by courier will arrive safely at its destination? Every time you remember to add the destination's PIN Code, your letter's chances of reaching its intended recipient improve.<br/><br/>
            Because India is such a large country with so many cities, towns, and villages, identifying the appropriate place or person might be difficult for the Indian Postal Service (and for courier services). On 15 August 1972, the Indian Postal Service established the 6-digit Postal Index Number (PIN) Code to improve the efficiency of letter and parcel delivery.<br/><br/>
            The Indian Postal Service has assigned nine separate PIN zones across the country, eight of which are geographical regions and one for the Indian Army.
            </p>

            <h2>Pin Code Structure (Postal Index Number)</h2>
            <p>
            Each of the six digits in the number has a distinct significance. The first digit indicates the main geographical region, while the first two digits indicate the postal circle or sub-region. The sorting district is designated by the third digit. Thus, the first three numbers represent the postal district as a whole, whereas the following three digits designate the individual post office inside the district.<br/><br/>
            Here's an example of how to decode your pin code. Central Delhi's postal code is 110001.
            <img src={PincodeImg} style={{ width:"100%" , marginTop: "20px" ,marginBottom:"20px" }} alt="Pincode-Structure"/> 
            The first digit indicates: northern region = 1<br/><br/>

            The first 2 digits indicate: postal circle Delhi = 11<br/><br/>

            The third digit indicates: sorting district = 0<br/><br/>

            The last 3 digits indicate: the specific post office (Connaught Place) = 001<br/><br/>

            Thus the 6-digit Pincode for Connaught Place in Central Delhi = 110001<br/><br/>
            </p>
            <h2>India's Zones and Distributions of First 2 digits of PIN Code on a Map</h2>
            <img src={Map} style={{ width:"100%" , marginTop: "20px" ,marginBottom:"20px" }} alt='India-Pincode-map'/> 
          </div>  

             
        </div>
    </div>
    </>
  );
}

export default PincodeAccess





